import { render, staticRenderFns } from "./SvgSetting.vue?vue&type=template&id=6b439c3a&scoped=true"
import script from "./SvgSetting.vue?vue&type=script&lang=js"
export * from "./SvgSetting.vue?vue&type=script&lang=js"
import style0 from "./SvgSetting.vue?vue&type=style&index=0&id=6b439c3a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b439c3a",
  null
  
)

export default component.exports